import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding-bottom: 8px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;
export const ModalTitle = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: ${({ theme }) => theme.fontSize.large};
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.2px;
`;

export const ModalDescription = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.normal};
  font-weight: 400;
  line-height: 20px;
`;

export const EmojiWrapper = styled.div`
  display: flex;
  width: 80px;
  height: 80px;
  padding: 12px 13px 13px 12px;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
`;

export const EmojiSpan = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-size: 55px;
  font-weight: 600;
  letter-spacing: -0.5px;
`;
